import React from 'react';
import { RotateCcw } from 'react-feather';

import Paging from '@/shared/components/Common/Paging';
import SearchBar from '@/shared/components/Common/SearchBar';
import { useInitialPage } from '@/shared/hooks/useInitialPage';
import { useKeywordList } from './hooks/useKeywordList';

import KeywordListTable from './components/UI/KeywordListTable';
import KeywordManageModal from './components/UI/KeywordManageModal';

const KeywordListPage: React.FC = () => {
  useInitialPage();

  const {
    keywordGroups,
    currentPage,
    totalPages,
    keyword,
    isLoading,
    hasError,
    isEmpty,
    shouldReset,
    totalCount,
    isModalOpen,
    selectedKeywordGroupId,
    handlePageChange,
    handleSearch,
    handleReset,
    handleResetComplete,
    handleRefresh,
    handleGroupClick,
    handleOpenModal,
    handleCloseModal,
    error,
  } = useKeywordList();

  return (
    <div className="min-h-screen bg-[#F1F1F1]">
      <div className="px-8 pt-6">
        <h2 className="text-2xl font-bold">Keyword</h2>

        <div className="mb-5 flex justify-end gap-2">
          <button
            type="button"
            className="flex h-7 w-7 cursor-pointer items-center justify-center rounded bg-[#E2E2E2] transition-colors hover:bg-opacity-80"
            onClick={handleReset}
            disabled={isLoading}
          >
            <RotateCcw size={16} className="text-[#1D1D1D]" />
          </button>

          <button
            type="button"
            className="flex h-7 items-center rounded-[4px] bg-[#3E3E3E] px-3 text-sm font-medium text-white shadow-md hover:opacity-80"
            onClick={handleOpenModal}
          >
            Add Keyword
          </button>
        </div>

        {/* Search Box */}
        <SearchBar
          onSearch={handleSearch}
          shouldReset={shouldReset}
          onResetComplete={handleResetComplete}
          initialValue={keyword}
        />

        <KeywordListTable
          keywordGroups={keywordGroups}
          isLoading={isLoading}
          hasError={hasError}
          isEmpty={isEmpty}
          error={error}
          onGroupClick={handleGroupClick}
        />

        {/* Pagination */}
        {!isLoading && !hasError && totalPages > 0 && (
          <div className="flex-none border border-x-[#DEDEDE] bg-[#E8E8E8] pb-4 pt-3">
            <Paging
              currentPage={currentPage}
              setCurrentPage={handlePageChange}
              totalPage={totalPages}
            />
          </div>
        )}

        {/* Modal */}
        <KeywordManageModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          selectedKeywordId={selectedKeywordGroupId}
        />
      </div>
    </div>
  );
};

export default KeywordListPage;
